import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const DeletedAgePage = lazy(() => import('./DeletedAgePage'));

const path = 'reports/age/delete';
const DeletedAgeRoute: FuseRouteItemType = {
	path: path,
	element: <DeletedAgePage />,
	settings: {
		layout: {
			config: {
				toolbar: {
					title: 'Domain Age Analysis for Deleted Domains',
					showCrumbs: false,
					helpName: 'Age Delete'
				},
			}
		}
	}
};

export default DeletedAgeRoute;
